<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { Dialog, DialogPanel, TransitionChild, TransitionRoot } from '@headlessui/vue';
import PaymentInner from '@/dashboard/vue/components/popups/PaymentPopup/PaymentInner.vue';
import SummaryInner from '@/dashboard/vue/components/popups/PaymentPopup/SummaryInner.vue';
import { POPUPS_ANIMATION } from '../../constants/popups';
import { PaymentStep, usePurchaseStore } from '@/dashboard/store/purchaseStore';
import PaymentAddress from '@/dashboard/vue/components/popups/PaymentPopup/PaymentAddress.vue';
import PopupsSuccessInner from '@/dashboard/vue/components/popups/PopupsSuccessInner.vue';

const purchaseStore = usePurchaseStore();

const { isOpenPopup, step } = storeToRefs(purchaseStore);
</script>

<template>
  <TransitionRoot :show="isOpenPopup" as="template">
    <Dialog :open="true" class="fixed bottom-zero left-zero right-zero top-zero z-[5000]">
      <!-- The backdrop, rendered as a fixed sibling to the panel container -->
      <TransitionChild
        as="template"
        :enter="POPUPS_ANIMATION.background.enter"
        :enter-from="POPUPS_ANIMATION.background.enterFrom"
        :enter-to="POPUPS_ANIMATION.background.enterTo"
        :leave="POPUPS_ANIMATION.background.leave"
        :leave-from="POPUPS_ANIMATION.background.leaveFrom"
        :leave-to="POPUPS_ANIMATION.background.leaveTo"
      >
        <div class="inset-0 fixed bottom-zero left-zero right-zero top-zero h-full w-full bg-gray-250/60 dark:bg-black/60" aria-hidden="true" />
      </TransitionChild>

      <!-- Full-screen container to center the panel -->
      <TransitionChild
        as="template"
        :enter="POPUPS_ANIMATION.content.enter"
        :enter-from="POPUPS_ANIMATION.content.enterFrom"
        :enter-to="POPUPS_ANIMATION.content.enterTo"
        :leave="POPUPS_ANIMATION.content.leave"
        :leave-from="POPUPS_ANIMATION.content.leaveFrom"
        :leave-to="POPUPS_ANIMATION.content.leaveTo"
      >
        <div class="absolute h-full w-full overflow-auto p-[47px]">
          <div class="flex min-h-full flex-1 items-center justify-center">
            <DialogPanel class="h-auto overflow-hidden rounded-16 bg-white text-center dark:bg-gray-950">
              <PaymentInner v-if="step === PaymentStep.Choose" />
              <PaymentAddress v-else-if="step === PaymentStep.Address" />
              <SummaryInner v-else-if="step === PaymentStep.Payment" />
              <PopupsSuccessInner v-else-if="step === PaymentStep.Success" :title="'Payment was successful. Plan has been changed!'" />
            </DialogPanel>
          </div>
        </div>
      </TransitionChild>
    </Dialog>
  </TransitionRoot>
</template>
